type NavigationButtonProps = {
  text: string;
  link: string;
  className?: string;
};

export const NavigationButton = ({
  text,
  link,
  className,
}: NavigationButtonProps) => {
  return (
    <a
      href={link}
      className={`text-black hover:text-primary transition-colors ${className}`}
    >
      {text}
    </a>
  );
};
